import React, { useEffect } from "react";
import { Col, Row, Badge, Avatar, Skeleton } from "antd";
import { LoadingOutlined } from "@ant-design/icons"
import "./TimesheetDetails.css";
import TimesheetDetailsCard from "../components/TimesheetDetailsCard/TimesheetDetailsCard";
import Chart from "../components/Chart/Chart";
import TopDrawer from "../components/topDrawer/topDrawer";
import TotalDetails from "../components/TimesheetDetailsCard/TotalDetails";
import CorrectionModal from "../components/CorrectionModal/correctionModa";
import RequestCard from "../components/RequestCard/RequestCard";
import Star23 from "../../../assets/icons/Star23.png";

import CustomCalendar from "../components/customCalendar/customCalendar";
import { getTimesheet, approveTimesheet } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

//import TopAlert from "../../components/TopNotification/TopAlert";

import TopAlert from "../../../components/TopNotification/TopAlert";

const TimesheetDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [deatilCursor, setDetailCursor] = React.useState("default");
  const [dimensions, setDimensions] = React.useState(window.innerWidth);
  const [showDrawer, setShowDrawer] = React.useState();
  const [startdate, setStartdate] = React.useState();
  const [enddtae, setEnddate] = React.useState();
  const [timesheetId, setTimesheetId] = React.useState();
  const [timehseetDate, setTimesheetDate] = React.useState();
  const [timesheetStartTime, setTimesheeStartTime] = React.useState();
  const [timesheetEndTime, setTimesheeEndTime] = React.useState();

  const timesheet = useSelector(
    (state) => state.TimesheetDetailsReducer.timesheetDetails
  );
  const loading = useSelector((state) => state.TimesheetDetailsReducer.loading);
  const approveTimeSheetLoading = useSelector((state) => state.TimesheetDetailsReducer.approveTimeSheetLoading);
  const rejectTimeSuccess = useSelector(state => state.rejectTimeSheetReducer.success)
  const timeSheetApprovalSuccess = useSelector((state) => state.TimesheetDetailsReducer.timeSheetApprovalSuccess);
  const timeSheetApprovalResponse = useSelector((state) => state.TimesheetDetailsReducer.timeSheetApprovalResponse);
  const rejectTimeSheetLoading = useSelector((state) => state.rejectTimeSheetReducer.loading);


  const handleReject = () => {
    setDetailCursor("pointer");
  };
  const handleDrawer = () => {
    setShowDrawer(true);
  };

  useEffect(() => {
    setDetailCursor('default')
    if (startdate && enddtae)
      dispatch(getTimesheet(location.state.id, startdate, enddtae));
  }, [startdate, enddtae, rejectTimeSuccess, timeSheetApprovalSuccess]);

  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);


  return (
    <div className="main-parent-div">

      {dimensions < 769 ? (
        <TopDrawer open={showDrawer} close={setShowDrawer} startTime={timesheetStartTime}
          endTime={timesheetEndTime} date={timehseetDate} id={timesheetId}
        />
      ) : (
        <CorrectionModal open={showDrawer} close={setShowDrawer} startTime={timesheetStartTime}
          endTime={timesheetEndTime} date={timehseetDate} id={timesheetId}
        />
      )}
      <Col className="candidate-profile-column">
        <div>
          <Row className="timesheet-candidate-profile-div">
            <Col lg={1}>
              <Badge dot>
                <Avatar
                  className="timesheet-badge-circle"
                  src="https://joeschmoe.io/api/v1/random"
                  shape="circle"
                  size="large"
                />
              </Badge>
            </Col>
            <Col lg={14} className="candidate-details-container">
              <div className="candidate-details-name">
                {timesheet?.user?.name}
                <span className="candidate-details-rate-value">
                  <img src={Star23} alt="rate-icon" /> 4.8
                  <span className="candidate-details-rate-count"> (493)</span>
                </span>
              </div>
              <div className="candidate-details-skill-listing">
                {location.state.skill_listing}
              </div>
            </Col>
          </Row>
        </div>
        <div className="candidate-details-lower-div">{location.state.job_title}</div>
      </Col>

      <div className="timesheet-body">
        <div style={{ marginBottom: "15px" }}>
          <CustomCalendar setStartdate={setStartdate} setEnddate={setEnddate} />
        </div>

        {/* <div style={{paddingLeft:'15px'}}> */}
        {loading ? null :
          timesheet?.correctionRequest?.map((items, index) => {
            return <RequestCard {...items} key={index}/>;
          })}

        {deatilCursor !== "default" ? (
          <div className="pick-data-to-correct-text">
            Select date for correction request
          </div>
        ) : null}

        {loading ? <Skeleton active /> :

          timesheet?.timesheet?.length == 0 && timesheet?.correctionRequest?.length == 0 ?

            <div style={{ width: '50%', margin: 'auto', textAlign: 'center' }}>
              No more pending time sheet
            </div> :
            timesheet?.timesheet?.length > 0 ?
              timesheet?.timesheet?.map((items, index) => {
                return (
                  <Col
                    xs={24}
                    lg={24}
                    key={index}
                    style={{
                      marginBottom: dimensions > 769 ? "35px" : "19px",
                      cursor: deatilCursor,
                      marginTop: "15px",
                    }}
                    onClick={handleDrawer}
                  >
                    <TimesheetDetailsCard {...items} timesheetId={setTimesheetId} date={setTimesheetDate}
                      start={setTimesheeStartTime} end={setTimesheeEndTime}
                    />
                  </Col>
                );
              }) :

              timesheet?.correctionRequest?.length > 0 ? null :
                <div style={{ width: '50%', margin: 'auto', textAlign: 'center' }}>
                  Timesheet already approved
                </div>
        }

        {deatilCursor === "default" ? (
          <TotalDetails
            TotalAbsent={
              timesheet?.timesheet?.length
                ? timesheet.timesheet[0].TotalAbsents
                : null
            }
            BillAmountCalculated={
              timesheet?.timesheet?.length
                ? timesheet.timesheet[0].BillAmountCalculated
                : null
            }
          />
        ) : null}


        <Col>
          {/*{deatilCursor === "default" ? (*/}
          {deatilCursor === "default" ? (
            <div className="timesheet-btn-row">

              {rejectTimeSheetLoading ?
                <button className='timesheet-reject-button'
                  onClick={() => { }}><LoadingOutlined />
                </button>
                :
                <button
                  className={timesheet?.timesheet?.length > 0 ? "timesheet-reject-button" : "timesheet-reject-button-disabled"}
                  onClick={handleReject}
                >
                  Reject
                </button>}

              {approveTimeSheetLoading ?
                <button className='contractgig-next-btn'
                  onClick={() => { }}><LoadingOutlined />
                </button>
                :
                <button
                  className={timesheet?.timesheet?.length > 0 && timesheet?.correctionRequest?.length == 0 ? "timesheet-aprove-button" : "timesheet-aprove-button-disabled"}
                  onClick={() => dispatch(approveTimesheet(location.state.id, startdate, enddtae))}>
                  Approve
                </button>
              }

            </div>
          ) : null}
        </Col>
        <div>
          <Chart userassignmentId={location.state.id} />
        </div>
      </div>
    </div>
  );
};
export default TimesheetDetails;
